export function permissions(state) {
  return state.permissions;
}
export function meta(state) {
  return state.meta;
}
export function permission(state) {
  return state.permission;
}